export default "__VITE_ASSET__b64c09b5__"